(function () {
  const initSortedBlog = () => {
    const wrapper = document.querySelector('[data-sorted-blog]');
    if (!wrapper) return;

    const totalPagesInput = wrapper.querySelector('[data-total-pages]');
    const grid = wrapper.querySelector('.load-more-grid');
    const loadingIndicator = wrapper.querySelector('[data-sorted-blog-loading]');
    const controls = document.querySelector('[data-artist-blog-controls]');
    const searchInput = controls ? controls.querySelector('[data-artist-search]') : null;
    const filterSelect = controls ? controls.querySelector('[data-artist-filter]') : null;

    if (!totalPagesInput || !grid) return;

    const totalPages = parseInt(totalPagesInput.value, 10);
    let currentPage = parseInt(wrapper.querySelector('[data-current-page]').value, 10);
    const baseNextUrl = wrapper.querySelector('[data-next-url]').value;

    const applyFilters = () => {
      const query = ((searchInput && searchInput.value) || '').trim().toLowerCase();
      const medium = (filterSelect && filterSelect.value) || '';

      grid.querySelectorAll('.blog-articles__article').forEach((item) => {
        const title = item.dataset.title || '';
        const tags = (item.dataset.tags || '').split('|');

        const matchesSearch = !query || title.indexOf(query) !== -1;
        const matchesMedium = !medium || tags.indexOf(medium) !== -1;

        item.classList.toggle('is-hidden', !(matchesSearch && matchesMedium));
      });
    };

    const enableFilters = () => {
      if (searchInput) {
        searchInput.removeAttribute('disabled');
        searchInput.addEventListener('input', applyFilters);
      }
      if (filterSelect) {
        filterSelect.removeAttribute('disabled');
        filterSelect.addEventListener('change', applyFilters);
      }
    };

    const sortArticles = () => {
      const items = Array.from(grid.querySelectorAll('.blog-articles__article'));
      items.sort((a, b) =>
        (a.dataset.sortKey || '').localeCompare(b.dataset.sortKey || '', undefined, {
          sensitivity: 'base',
        })
      );
      items.forEach((item) => grid.appendChild(item));

      if (loadingIndicator) loadingIndicator.remove();
      wrapper.classList.remove('is-loading');
      enableFilters();
    };

    const loadNextPage = () => {
      if (!totalPages || currentPage >= totalPages) {
        sortArticles();
        return;
      }

      currentPage += 1;
      const nextUrl = baseNextUrl.replace(/page=[0-9]+/, 'page=' + currentPage);

      $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function (responseHTML) {
          $(grid).append($(responseHTML).find('.load-more-grid').html());
        },
        complete: function () {
          wrapper.querySelector('[data-current-page]').value = currentPage;
          loadNextPage();
        },
      });
    };

    loadNextPage();
  };

  document.addEventListener('DOMContentLoaded', initSortedBlog);
})();